<template>
  <div
    class="container-fluid weeducDashboardPanel weeduc-admin-panel edit-panel-page page-card panel-container text-left p-0"
  >
    <header class="edit-panel-header">
      <div class="edit-panel-header__lead">
        <TitlePage
          :title="$t('admin.panel.title')"
          :subtitle="$t('admin.panel.subtitle')"
          :hasMargin="false"
        />
      </div>
    </header>

    <div class="edit-panel-shell">
      <div class="cardsContainer edit-panel-cards">
      <div class="columns">
        <!-- Coluna 1 -->
        <div class="column edit-panel-column edit-panel-column--side">
          <div class="card-sm fastAccess">
            <div class="titleCard">
              <h4>{{ $t('admin.panel.quickAccess') }}</h4>
            </div>
            <button class="fastAccessBtn" @click="$router.push('/dashboard/form-curso')">
              <fa icon="fa-plus"/>
              {{ $t('admin.panel.newCourse') }}
            </button>
            <button class="fastAccessBtn" @click="$router.push('/dashboard/avisos')">
              <fa icon="fa-bell"/>
              {{ $t('admin.panel.newWarning') }}
            </button>
            <button class="fastAccessBtn flat" @click="$router.push('/dashboard/relatorios')">
              {{ $t('admin.panel.salesReport') }}
            </button>
          </div>

          <div class="row accessInfo">
            <div class="card-sm edit-panel-stat-card" style="width: 100%;min-height: 100px;position: relative; cursor: pointer;" @click="$router.push('/dashboard/duvidas')">
              <div class="titleCard" v-if="hasReady">
                <h4>{{ $t('admin.panel.doubts') }} <fa icon="fa-arrow-right" style="float: right;"/></h4>
              </div>
              <div class="contentCard" v-if="hasReady">
                <h3>{{unansweredQuestions}}</h3>
                <p>{{ $t('admin.panel.unansweredDoubts') }}</p>
              </div>
              <Loader :isActive="hasReady"/>
            </div>
            <div class="card-sm edit-panel-stat-card" style="width: 100%;min-height: 100px;position: relative; cursor: pointer;" @click="$router.push('/dashboard/cursos')">
              <div class="titleCard" v-if="hasReady">
                <h4>{{ $t('admin.panel.courses') }} <fa icon="fa-arrow-right" style="float: right;"/></h4>
              </div>
              <div class="contentCard" v-if="hasReady">
                <h3>{{availableCourses}}</h3>
                <p>{{ $t('admin.panel.availableCourses') }}</p>
              </div>
              <Loader :isActive="hasReady"/>
            </div>

            <div class="card-sm edit-panel-stat-card" style="width: 100%;min-height: 100px;position: relative; cursor: pointer;" @click="$router.push('/dashboard/forum')">
              <div class="titleCard" v-if="hasReady">
                <h4>{{ $t('admin.panel.forum') }} <fa icon="fa-arrow-right" style="float: right;"/></h4>
              </div>
              <div class="contentCard" v-if="hasReady">
                <h3>{{forumInteractions}}</h3>
                <p>{{ $t('admin.panel.forumInteractions') }}</p>
              </div>
              <Loader :isActive="hasReady"/>
            </div>
            <div class="card-sm edit-panel-stat-card" style="width: 100%;min-height: 100px;position: relative; cursor: pointer;" @click="$router.push('/dashboard/cursos')">
              <div class="titleCard" v-if="hasReady">
                <h4>{{ $t('admin.panel.activities') }} <fa icon="fa-arrow-right" style="float: right;"/></h4>
              </div>
              <div class="contentCard" v-if="hasReady">
                <h3>{{activities}}</h3>
                <p>{{ $t('admin.panel.activities') }}</p>
              </div>
              <Loader :isActive="hasReady"/>
            </div>
          </div>
        </div>

        <!-- Coluna 2 -->
        <div class="column edit-panel-column edit-panel-column--center">
          <div class="card-lg edit-panel-chart-card" style="min-height: 300px;position: relative;">
            <div class="titleCard">
              <h4 style="position: absolute; top: 20px; left: 20px">{{ $t('admin.panel.students') }}</h4>
              <h4 class="card-text-title" style="position: absolute; top: 20px; right: 20px" v-if="hasReady">{{ totalStudentsFormatted }}</h4>
            </div>
            <Chart v-if="hasReady" :title="$t('admin.panel.studentsChartTitle')" :nameChart="$t('admin.panel.students')" :data="dataChartUser" :isDark="dark"/>
            <Loader :isActive="hasReady"/>
          </div>

          <div class="card-lg edit-panel-chart-card" style="min-height: 300px;position: relative;">
            <div class="titleCard">
              <h4 style="position: absolute; top: 20px; left: 20px">{{ $t('admin.panel.sales') }}</h4>
              <h4 class="card-text-title" style="position: absolute; top: 20px; right: 20px" v-if="hasReady">{{ revenueFormatted }}</h4>    
            </div>
            <Chart v-if="hasReady" :title="$t('admin.panel.sales')" :nameChart="$t('admin.panel.salesChartName')" :data="dataChartEnrol" :isDark="dark"/>
            <Loader :isActive="hasReady"/>
          </div>
        </div>

        <!-- Coluna 3 -->
        <div class="column edit-panel-column edit-panel-column--side">
          <div class="students-cards edit-panel-side-block" style="min-height: 210px;position: relative;">
            <h4>{{ $t('admin.panel.students') }}</h4>
            <div class="row" v-if="hasReady">
              <div class="card-sm students" style="width: 100%">
                <div class="contentCard">
                  <p>{{ $t('admin.panel.newThisMonth') }}</p>
                  <h3>{{newStudents}}</h3>
                </div>
              </div>

              <div class="card-sm students" style="width: 100%">
                <div class="contentCard">
                  <p>{{ $t('admin.panel.activeStudents') }}</p>
                  <h3>{{activeStudents}}</h3>
                </div>
              </div>
            </div>
            <Loader :isActive="hasReady"/>
          </div>

          <div class="popular-courses edit-panel-side-block" style="min-height: 300px;position: relative;">
            <div class="titleCard">
              <h4>{{ $t('admin.panel.popularCourses') }}</h4>
              <small>{{ $t('admin.panel.last30Days') }}</small>
            </div>
            <div class="contentLastVideos" v-if="hasReady">
              <div class="subtitles">
                <small>{{ $t('admin.panel.course') }}</small>
                <small>{{ $t('admin.panel.enrolments') }}</small>
              </div>
              <div class="contentVideo" v-for="course in popularCourses?.slice(0,5) || []" :key="course.id">
                <div class="videoContent">
                  <img :src="course.imageFinalPath" :alt="course.name">
                  <h5>{{course.name}}</h5>
                </div>
                <h5>{{course.enrols}}</h5>
              </div>
              <button class="see-all-btn" @click="$router.push('/dashboard/cursos')">{{ $t('admin.panel.seeCourseList') }}</button>
            </div>
            <Loader :isActive="hasReady"/>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '@/components/Charts/chartPanel.vue'
import { mapState } from 'vuex'
import api from '@/utils/dashboard'
import Loader from '@/components/Loader/loader.vue'
import TitlePage from '@/components/Weflix/titlePage.vue'
import { toast } from 'vue3-toastify';
import { intlLocale } from '@/i18n/locale';

export default {
  components: {
    Chart,
    Loader,
    TitlePage,
  },
  
  data() {
    return {
      hasReady: false,
      dataChartUser: {},
      dataChartEnrol: {},
      newStudents: 0,
      activeStudents: 0,
      revenue: 0,
      unansweredQuestions: 0,
      forumInteractions: 0,
      popularCourses: [],
      availableCourses: 0,
      activities: 0,
    }
  },

  computed: {
    ...mapState(['token', 'user', 'dark']),
    totalStudentsFormatted() {
      return new Intl.NumberFormat(intlLocale(this.$i18n.locale)).format(
        this.newStudents + this.activeStudents
      );
    },
    revenueFormatted() {
      if (this.revenue == null) return '';
      return new Intl.NumberFormat(intlLocale(this.$i18n.locale), {
        style: 'currency',
        currency: 'BRL',
      }).format(this.revenue);
    },
  },
  methods: {
    async fetchDashboardData() {
      try {
        const response = await api.getDataPnel(this.token)
        this.dataChartUser = (response.students && response.students.length > 0 && response.students.some(item => item.value > 0)) ? response.students : [];
        this.dataChartEnrol = (response.sales && response.sales.length > 0 && response.sales.some(item => item.value > 0)) ? response.sales : [];
        this.newStudents = response.studentsNew;
        this.activeStudents = response.studentsActive;
        this.revenue = (response.sales && response.sales.length > 0) ? response.sales.reduce((total, sale) => total + sale.value, 0) : null;
        this.unansweredQuestions = response.inquiries;
        this.forumInteractions = response.forumInteractions;
        this.activities = response.activities;
        this.availableCourses = response.courses
        this.popularCourses = response.coursesPopular

        this.hasReady = true
      } catch (error) {
        const errorMessage = error.response?.data?.message || this.$t('admin.panel.loadError')
        toast.error(errorMessage)
        this.hasReady = true
      }
    },
  },
  async created() {
    await this.fetchDashboardData()
  },
}
</script>

<style>
.panel-container .apexcharts-canvas.apexcharts-theme- {
    width: 100%;
    max-width: 510px;
    height: 300px;
  }
</style>

<style scoped>
.content.dashboard > .container {
    padding-bottom: 0;
       background-color: transparent;
}

.edit-panel-page.weeduc-admin-panel.page-card {
  background: #f4f5f8;
  border-radius: 16px;
  padding: 0 0 1rem;
  box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
}

.edit-panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  padding: 1.25rem 1.5rem 1rem;
  background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
  border-bottom: 1px solid #e8eaf0;
  border-radius: 16px 16px 0 0;
}

.edit-panel-header__lead {
  flex: 1;
  min-width: 200px;
}

.edit-panel-header__lead :deep(.titlelayoutGeneric) {
  border-bottom: none;
  padding-bottom: 0;
}

.edit-panel-header__lead :deep(.titlelayoutGeneric h3) {
  font-size: 1.5rem;
  margin: 0 0 0.35rem;
  color: #1a1d26;
}

.edit-panel-header__lead :deep(.titlelayoutGeneric small) {
  display: block;
  color: #5c6370;
  line-height: 1.45;
}

.edit-panel-shell {
  padding: 1.25rem 1.5rem 1.5rem;
  height: calc(100vh - 210px);
  overflow-y: auto;
  min-height: 0;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.edit-panel-shell::-webkit-scrollbar {
  display: none;
}



.edit-panel-column--side {
  flex: 0.3;
  min-width: 0;
}

.edit-panel-column--center {
  flex: 0.4;
  min-width: 0;
}

.columns {
  display: flex;
  gap: 1.5rem;
}

.column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cardsContainer .row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  margin-bottom: 1.5rem;
}

.card-sm {
  width: calc(50% - 0.75rem);
  padding: 10px 20px;
  border-radius: 12px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-sm:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* Fix: dashboard/painel style */

.weeducDashboardPanel .card-sm {
  border: 1px solid #e0e0e0;
}

.weeducDashboardPanel .card-sm.students {
  border: none;
}

.weeducDashboardPanel .card-sm.fastAccess {
  border: none;
}

.weeducDashboardPanel .contentCard h3 {
  color: #160266 !important;
}

.weeducDashboardPanel .contentCard p {
  color: #666666 !important;
}

.weeducDashboardPanel .videoContent h5 {
    color: #2C3E50 !important;
    text-align: left;
}

.weeducDashboardPanel .titleCard svg {
  display: none;
}

.weeducDashboardPanel .card-lg {
  border: 1px solid #e0e0e0;
}

.weeducDashboardPanel .card-text-title {
  color: #160266 !important;
}

.weeducDashboardPanel .students-cards {
  border: 1px solid #e0e0e0;
}

.weeducDashboardPanel .popular-courses {
  border: 1px solid #e0e0e0;
}

.weeducDashboardPanel .see-all-btn {
  color: #160266 !important;
}

.weeducDashboardPanel button.see-all-btn:hover {
  background-color: #250991;
  color: #ffffff !important;
}

/* Fix: dashboard/painel style */

.card-lg {
  width: 100%;
  padding: 15px;
  border-radius: 12px;
  text-align: left;
  background-color: #ffffff;
  position: relative;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-lg:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.card-sm.fastAccess {
    width: 100%;
    background-color: transparent;
    padding: 0;
    box-shadow: none;
}

.contentCard {
    padding: 0;
    text-align: left;
    display: flex
;
    gap: 10px;
    align-items: center;
}

.contentCard h3 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0rem;
}

.contentCard p {
  color: #666666;
  font-size: 0.875rem;
  margin-bottom: 0rem;
}

.titleCard {
  text-align: left;
  margin: 1rem 0;
  margin-bottom: 1.5rem;
}

.titleCard h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
}

.titleCard small {
  color: #666666;
  font-size: 0.75rem;
}

button.fastAccessBtn {
    width: 100%;
    background-color: #160266;
    margin: 0.75rem 0;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff;
    transition: all 0.2s ease;
    border: none;
    cursor: pointer;
    gap: 0.5rem;
}

button.fastAccessBtn:hover {
  background-color: #250991;
  color: #ffffff;
}

button.fastAccessBtn svg {
  color: inherit;
}

.students-cards h4 {
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
}

.popular-courses {
  background-color: #ffffff;
  padding: 10px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.contentVideo {
  display: flex;
  justify-content: space-between;
  margin: 5px 0px;
  align-items: center;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 500ms ease-in-out;
  gap: 20px;
}

.contentVideo:hover {
  background-color: #f3f9f9;
  cursor: pointer;
  transform: translateX(5px);
}

.videoContent {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.videoContent img {
    width: 80px;
    height: 50px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.videoContent h5 {
      font-size: 12px;
    font-weight: 600;
    color: #929292;
}
.contentVideo h5 {
    font-size: 15px;
}

.subtitles {
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
}

.subtitles small {
  font-size: 0.75rem;
  color: #666666;
  font-weight: 500;
}

.see-all-btn {
    width: 100%;
    background-color: #ffffff;
    color: #9b9b9b;
    padding: 11px;
    border-radius: 8px;
    margin-top: 1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 11px;
    margin-bottom: 8px;
}

.see-all-btn:hover {
  background-color: #250991;
  color: #ffffff;
}

@media (max-width: 768px) {
  .columns {
    flex-direction: column;
    gap: 0 !important;
  }
  
  .column {
    flex: none !important;
    gap: 0 !important;
  }

  .card-sm {
    width: 100%;
  }

  .cardsContainer .row {
    margin-bottom: 10px !important;
  }

  .edit-panel-column--side,
  .edit-panel-column--center {
    flex: none !important;
  }

  .column .card-lg,
  .column .students-cards {
    margin-bottom: 10px;
  }
}
.students-cards {
    background-color: white;
    padding: 15px;
    border-radius: 10px;
    text-align: left;
}
.card-sm.students {
    background-color: #f3f9f9;
}
.card-sm.students .contentCard {
    justify-content: space-between;
}
.popular-courses .titleCard {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
button.fastAccessBtn.flat {
    background-color: transparent;
    color: #160565;
    border: 2px solid #160565;
}

button.fastAccessBtn.flat:hover {
    background-color: #160565;
    color: #ffffff;
}
.card-sm.students .contentCard p {
    color: #160565;
    font-size: 15px;
    margin-bottom: 0rem;
    font-weight: 700;
}
.card-sm.students .contentCard h3 {
    color: #160565;
}
.row.accessInfo .contentCard h3 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1ac5cf;
    margin-bottom: 0rem;
}
</style>

<style>
/**
 * Dark mode — Painel (weeduc-admin-panel / edit-panel-page)
 */
.dashboard.dark .weeduc-admin-panel.edit-panel-page.page-card {
  background: #1c1d24;
  border: 1px solid #2f323c;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}

.dashboard.dark .weeduc-admin-panel .edit-panel-header {
  background: linear-gradient(145deg, #23252e 0%, #1c1d24 100%);
  border-bottom-color: #353945;
}

.dashboard.dark .weeduc-admin-panel .edit-panel-header__lead .titlelayoutGeneric h3 {
  color: #f1f3f7;
}

.dashboard.dark .weeduc-admin-panel .edit-panel-header__lead .titlelayoutGeneric small {
  color: #9ca3b4;
}

.dashboard.dark .weeduc-admin-panel .edit-panel-shell {
  scrollbar-color: #353945 transparent;
}

.dashboard.dark .fastAccessBtn.flat {
  background-color: transparent;
  color: #b4a9f0;
  border: 2px solid #4c3d8f;
  transition: all 0.2s ease-in-out;
}

.dashboard.dark .fastAccessBtn.flat:hover {
  background-color: #250891;
  color: #fff;
  border-color: #250891;
}

.dashboard.dark .weeducDashboardPanel .titleCard h4 {
  color: #f1f3f7;
}

.dashboard.dark .weeducDashboardPanel .contentCard p {
  color: #9ca3b4 !important;
}

.dashboard.dark .weeducDashboardPanel .students-cards h4 {
  color: #f1f3f7;
}

.dashboard.dark .weeducDashboardPanel .titleCard small {
  color: #9ca3b4;
}

.dashboard.dark .weeducDashboardPanel .subtitles small {
  color: #9ca3b4;
}

.dashboard.dark .weeducDashboardPanel .card-text-title,
.dashboard.dark .weeducDashboardPanel .contentCard h3 {
  color: #f1f3f7 !important;
}

.dashboard.dark .weeducDashboardPanel .videoContent h5 {
  color: #e4e6eb !important;
}

.dashboard.dark .weeducDashboardPanel .contentVideo h5 {
  color: #f1f3f7 !important;
}

.dashboard.dark .weeducDashboardPanel .contentVideo:hover {
  background-color: #323643;
}

.dashboard.dark .weeducDashboardPanel .row.accessInfo .card-sm,
.dashboard.dark .weeducDashboardPanel .row.accessInfo .edit-panel-stat-card {
  border: 1px solid #353945;
  background-color: #252730;
}

.dashboard.dark .weeducDashboardPanel .column .students-cards {
  border: 1px solid #353945;
  background-color: #252730;
}

.dashboard.dark .weeducDashboardPanel .card-sm.students {
  background-color: #2a2d36;
}

.dashboard.dark .weeducDashboardPanel .popular-courses {
  background-color: #252730;
  border: 1px solid #353945;
}

.dashboard.dark .weeducDashboardPanel .card-lg,
.dashboard.dark .weeducDashboardPanel .edit-panel-chart-card {
  background-color: #252730;
  border: 1px solid #353945;
}

.dashboard.dark .weeducDashboardPanel .card-sm {
  border-color: #353945;
}

.dashboard.dark .weeducDashboardPanel .see-all-btn {
  background-color: #323643 !important;
  color: #f1f3f7 !important;
  border: 1px solid #3d414d;
}

.dashboard.dark .weeducDashboardPanel .see-all-btn:hover {
  background-color: #250991 !important;
  color: #fff !important;
  border-color: #250891;
}

.dashboard.dark .card-sm.students .contentCard p {
  color: #b4a9f0 !important;
}

.dashboard.dark .card-sm.students .contentCard h3 {
  color: #f1f3f7 !important;
}
</style>
<style>
.panel-container button.fastAccessBtn svg path {
    fill: #ffffff!important;
}
.panel-container .loader1 {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid #250891!important;
  animation: l20-1-a9184be2 0.8s infinite linear alternate, l20-2-a9184be2 1.6s infinite linear;
  position: absolute;
  top: 27%!important;
  left: 44%!important;
  transform: translate(-50%, -50%);
}
.row.accessInfo svg.svg-inline--fa.fa-arrow-right {
  color: #160565;
}
</style>